import { render } from "./EmptyState.vue?vue&type=template&id=45bb7eaf&scoped=true"
import script from "./EmptyState.vue?vue&type=script&lang=js"
export * from "./EmptyState.vue?vue&type=script&lang=js"

import "./EmptyState.vue?vue&type=style&index=0&id=45bb7eaf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45bb7eaf"]])

export default __exports__